export const ACTION_LOADING = "BIKE_LOADING";
export const ACTION_ERROR = "BIKE_ERROR";
export const ACTION_GET_LIST = "ACTION_GET_LIST";
export const ACTION_GET_STATISTICS = "ACTION_GET_STATISTICS";
export const ACTION_RESET_LIST = "ACTION_RESET_LIST";
export const ACTION_PAYMENT_STATUS = "ACTION_PAYMENT_STATUS";
export const ACTION_TASK_TYPES = "ACTION_TASK_TYPES";
export const ACTION_GET_TRIP_BY_ID = "ACTION_GET_TRIP_BY_ID";
export const ACTION_EDIT_DURATION_BY_ID = "ACTION_EDIT_DURATION_BY_ID";



// WEBPACK FOOTER //
// ./src/actions/action/constants.js